/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineCate.vue?vue&type=template&id=2452a1c5&scoped=true"
import script from "./popMineCate.vue?vue&type=script&lang=js"
export * from "./popMineCate.vue?vue&type=script&lang=js"
import style0 from "./popMineCate.vue?vue&type=style&index=0&id=2452a1c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452a1c5",
  null
  
)

export default component.exports